import React, { useEffect, useState } from 'react';

import {
  TestCommentsWrapper,
  TestCommentsForm,
  TestCommentsTextArea,
  TestCommentsButton,
  TestCommentsResponse,
  TestCommentsResponseWrapper,
} from './styles.TestComments';

export const TestComments: React.FC = () => {
  type TestCommentsSubmit = {
    target: {
      text: {
        value: string;
      };
    };
  } & React.SyntheticEvent<HTMLFormElement>;

  type CommentApiResult = {
    id: string;
    comment_id: string;
    body: string;
    start: number;
    offset: number;
    label: string;
    extracted_from: string;
  };

  type CommentApiResponse = {
    status: string;
    msg: string;
    result: CommentApiResult[];
  };

  const [userData, setUserData] = useState('');
  const [mention, setMention] = useState(false);
  const [error, setError] = useState(false);

  const handleSubmit = (e: TestCommentsSubmit) => {
    e.preventDefault();
    const text = e.target.text.value;
    const newUserData = JSON.stringify({ text });

    if (newUserData.length && newUserData !== userData) {
      setUserData(newUserData);
    }

    return false;
  };

  const handleData = ({ result }: CommentApiResponse) => {
    if (result.length) {
      setMention(true);
    } else {
      setMention(false);
    }
  };

  const handleError = (error: any) => {
    setError(error);
  };

  useEffect(() => {
    if (userData.length) {
      fetch('https://wtwm-topic-modelling.brdata-dev.de/v1/find_mentions', {
        method: 'POST',
        headers: {
          Authorization:
            'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VybmFtZSI6ImJyZGF0YWFpbGFiIiwicGFzc3dvcmQiOiJAdDNZRW1iUGQ4ZEU5biIsImV4cGlyZXMiOjE3MDA5MzI4MDIuOTc3MjQ4Mn0.UA3_ZHxkAT2qt3yVZFND3xXPAWr7nnWGbS8i83madgc',
          'Content-Type': 'application/json',
        },
        body: userData,
      })
        .then((res) => res.json())
        .then(handleData, handleError);
    }
  }, [userData]);

  return (
    <TestCommentsWrapper>
      <TestCommentsForm onSubmit={handleSubmit}>
        <TestCommentsTextArea
          name="text"
          placeholder="Please enter a comment with direct mention of the editor"
          required
        />
        <TestCommentsResponseWrapper>
          <TestCommentsResponse
            type={error ? 'error' : mention ? 'mention' : 'blank'}
          >
            {error && 'Error: Could not get data'}
            {!error &&
              mention &&
              'Mention detected and sent for approval to the newsroom via MS Teams.'}
            {!error && !mention && 'No mention detected'}
          </TestCommentsResponse>
          <TestCommentsButton type="submit" value="Analyze" />
        </TestCommentsResponseWrapper>
      </TestCommentsForm>
    </TestCommentsWrapper>
  );
};
